import { IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonTitle, IonToolbar } from '@ionic/react';

import { IonPageWrapper } from './ProfilePage.styles';
import { alertCircleOutline, power } from 'ionicons/icons';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { signOutAsync } from '../../store/authSlice';
import { RouteNames } from '../../models/routes.model';
import { useOtpModal } from '../../providers/OtpModalProvider';

interface IComponentProps {}

const ProfilePage: React.FC<IComponentProps> = () => {
  const { token } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const {
    actions: { showOtpModal },
  } = useOtpModal();

  const handleClickSignOut = () => {
    dispatch(signOutAsync());
  };

  return (
    <IonPageWrapper>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton defaultHref={RouteNames.dashboard} color="secondary" />
          </IonButtons>
          <IonTitle>Profile</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color="lightest">
        <IonList>
          {!token?.hasOtp && (
            <IonItem button detail={true} lines="full" onClick={() => showOtpModal()}>
              <IonIcon icon={alertCircleOutline} size="large" color="warning" slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">
                <h3>Two-Step Authentication</h3>
                <p>You do not have two-step authentication enabled</p>
              </IonLabel>
            </IonItem>
          )}
          <IonItem lines="none" button onClick={() => handleClickSignOut()}>
            <IonLabel>Sign Out</IonLabel>
            <IonIcon slot="end" color="danger" icon={power}></IonIcon>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPageWrapper>
  );
};

export default ProfilePage;
